// @flow

import _ from 'lodash';
import Q from 'q';

import fetch from 'fetch';

import serverApiVersioning from 'server-api-versioning';
import clientSource from 'client-source';

import deprecate from 'util-deprecate';

import type { LogContextInterface } from 'log-context';
import type { AuthContextInterface } from 'auth-context';

import { sessionId } from 'session-id';

import { getStatisticsHeaders } from 'app-my-dms-insurance/app/utils/get-statistics-headers';


// TODO: no any
type Server = any;
type Host = any;

type MethodFunction = typeof fetch;
type MethodBuilderFunction = (MethodFunction, ?Server) => MethodFunction;

export type ServerMethodOptions = {
	body?: Object,
	query?: Object,
	headers?: Object,
	logContext?: LogContextInterface,
	authContext?: AuthContextInterface,
};

export type ServerMethod = (ServerMethodOptions) => Promise<Response>;

type BeforeAjaxCallback = (ServerMethodOptions, ?Host) => ServerMethodOptions;
type AfterAjaxCallaback = (Promise<Response>, ?Host) => Promise<Response>;


module.exports = function Method (
	method: Object | MethodBuilderFunction,
	name: string,
	host: any
): ServerMethod {
	const fetch_: MethodFunction = (function () {
		if (_.isFunction(method)) {
			method = ((method: any): MethodBuilderFunction);
			return method(fetch, host._server);
		} else if (_.isObject(method)) {
			return fetch;
		}
		throw new Error("Can't create the '" + name + "' method");
	}());

	const beforeAjax: BeforeAjaxCallback
		  = (method._beforeAjax && method._beforeAjax.bind(method))
		|| (host._beforeAjax && host._beforeAjax.bind(host))
		|| _.identity;
	const afterAjax: AfterAjaxCallaback
		  = (method._afterAjax && method._afterAjax.bind(method))
		|| (host._afterAjax && host._afterAjax.bind(host))
		|| _.identity;

	let resultMethod = (function () {
		let mock = null;
		const statHeaders = getStatisticsHeaders();

		const mockableMethod = function (options?: ServerMethodOptions = {}) {
			options = _.defaultsDeep({}, options, method, {
				url: name,

				headers: _.defaults({}, ...[
					serverApiVersioning.getAdditionalRequestHeaders(),

					// HACK: Add header to all requests as a fast & dirty hotfix (hopefully TEMPORARY)
					clientSource.getAdditionalRequestHeaders(),

					options.authContext
						? options.authContext.getAdditionalRequestHeaders()
						: {},

					options.logContext
						? options.logContext.getAdditionalRequestHeaders()
						: {},

					{
						// HACK: can't use root log context
						// due to circular dependency between `server` and `log-context`
						'x-splunk-log-sessionid': sessionId(),
						...statHeaders,
					},
				]),
			});

			let fetchMocked = fetch_;

			if (mock && mock.json) {
				fetchMocked = function fetchMockedJSON (url, options) {
					mock = ((mock: any): Object);

					console.groupCollapsed('server method call mocked %o', url);
					console.log('options: %o', options);
					console.log('response: %o', mock.json);
					console.groupEnd();

					return Q.delay(1000 * Math.random())
						.then(() => ({
							status: 200,
							json: () => Q(((mock: any): Object).json),
						}));
				};
			}

			return Q(beforeAjax(options, host)).then(function (options) {
				return afterAjax(fetchMocked(options.url, options), host);
			});
		};

		mockableMethod._unmock = function unmockServerMethod () {
			mock = null;
		};

		mockableMethod._mock = function mockServerMethod () {
			throw new Error('TODO');
		};

		mockableMethod._mock.json = function mockServerMethodWithJSON (json) {
			mock = { json };
		};

		return mockableMethod;
	}());

	if (method.deprecate) {
		resultMethod = deprecate(resultMethod, method.deprecate);
	}

	return resultMethod;
};


